import React, { useState, useEffect } from 'react';
import { Dropdown, Modal } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { courseAddFldetsInfo, courseFldetsValidationOptions } from 'dsoapi';
import NextGatherInfoUrl from './NextGatherInfoUrl';

const genders = [
  { text: 'Male', value: 'M' },
  { text: 'Female', value: 'F' },
];

const emptyQuestionOptions = {
  question1: [],
  question2: [],
  question3: [],
  question4: [],
  question5: [],
  question6: [],
};

const GatherInfoFLDETS = ({ uceId }) => {
  const [ssnLast_4, setSsnLast_4] = useState('');
  const [alienNumber, setAlienNumber] = useState('');
  const [nonAlienNumber, setNonAlienNumber] = useState('');
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedAnimal, setSelectedAnimal] = useState(null);
  const [selectedFood, setSelectedFood] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [selectedSport, setSelectedSport] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [questionOptions, setQuestionOptions] = useState(emptyQuestionOptions);
  const [showAlienModal, setShowAlienModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const resp = await courseFldetsValidationOptions();
      const mapOptions = (questions) => {
        return questions.map((option) => ({
          text: option,
          value: option,
        }));
      };
      setQuestionOptions({
        question1: mapOptions(resp.data.question1),
        question2: mapOptions(resp.data.question2),
        question3: mapOptions(resp.data.question3),
        question4: mapOptions(resp.data.question4),
        question5: mapOptions(resp.data.question5),
        question6: mapOptions(resp.data.question6),
      });
    };
    fetchData();
  }, [uceId]);

  const onSubmit = async (event) => {
    event.preventDefault();
    setShowValidation(true);
    if (
      ssnAlienPopulated() &&
      selectedGender &&
      selectedColor &&
      selectedAnimal &&
      selectedFood &&
      selectedSeason &&
      selectedMovie &&
      selectedSport
    ) {
      setSubmitting(true);
      const request = {
        ssnLast_4,
        alienNumber,
        nonAlienNumber,
        selectedGender,
        gender: selectedGender,
        validationQuestion1: selectedColor,
        validationQuestion2: selectedAnimal,
        validationQuestion3: selectedFood,
        validationQuestion4: selectedSeason,
        validationQuestion5: selectedMovie,
        validationQuestion6: selectedSport,
      };
      await courseAddFldetsInfo(uceId, request);
      const url = await NextGatherInfoUrl(uceId);
      setSubmitting(false);
      navigate(url);
    }
  };

  const ssnAlienPopulated = () => ssnLast_4 || alienNumber || nonAlienNumber;

  return (
    <form className="ui form" onSubmit={onSubmit}>
      <div className="ui container">
        <h4 className="ui dividing header">Enter DETS Information</h4>
        <div className="ui stackable grid">
          <div className="eight wide column">
            <p>
              The following questions are part of the state-required identity
              validation process. Your answers will be used to confirm your
              identity during the course, so please take note of them.
            </p>
            <div className="field">
              <label htmlFor="color">What is your favorite color?</label>
              <Dropdown
                name="color"
                style={{ maxHeight: '27rem' }}
                placeholder="Select favorite color"
                fluid
                selection
                options={questionOptions.question1}
                value={selectedColor}
                onChange={(_, { value }) => setSelectedColor(value)}
              />
              {showValidation && !selectedColor && (
                <p className="error">favorite color is required</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="animal">
                Which of these animals do you like most?
              </label>
              <Dropdown
                name="animal"
                style={{ maxHeight: '27rem' }}
                placeholder="Select favorite animal"
                fluid
                selection
                options={questionOptions.question2}
                value={selectedAnimal}
                onChange={(_, { value }) => setSelectedAnimal(value)}
              />
              {showValidation && !selectedAnimal && (
                <p className="error">favorite animal is required</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="food">What is your favorite type of food?</label>
              <Dropdown
                name="food"
                style={{ maxHeight: '27rem' }}
                placeholder="Select favorite food"
                fluid
                selection
                options={questionOptions.question3}
                value={selectedFood}
                onChange={(_, { value }) => setSelectedFood(value)}
              />
              {showValidation && !selectedFood && (
                <p className="error">favorite food is required</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="season">What is your favorite season?</label>
              <Dropdown
                name="season"
                style={{ maxHeight: '27rem' }}
                placeholder="Select favorite season"
                fluid
                selection
                options={questionOptions.question4}
                value={selectedSeason}
                onChange={(_, { value }) => setSelectedSeason(value)}
              />
              {showValidation && !selectedSeason && (
                <p className="error">favorite season is required</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="movie">
                What kind of movies do you like best?
              </label>
              <Dropdown
                name="movie"
                style={{ maxHeight: '27rem' }}
                placeholder="Select favorite movie genre"
                fluid
                selection
                options={questionOptions.question5}
                value={selectedMovie}
                onChange={(_, { value }) => setSelectedMovie(value)}
              />
              {showValidation && !selectedMovie && (
                <p className="error">favorite movie genre is required</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="sport">
                Which sport do you enjoy watching the most?
              </label>
              <Dropdown
                name="sport"
                style={{ maxHeight: '27rem' }}
                placeholder="Select favorite sport"
                fluid
                selection
                options={questionOptions.question6}
                value={selectedSport}
                onChange={(_, { value }) => setSelectedSport(value)}
              />
              {showValidation && !selectedSport && (
                <p className="error">favorite sport to watch is required</p>
              )}
            </div>
          </div>
          <div className="eight wide column">
            <div className="field">
              <label htmlFor="gender">Gender</label>
              <Dropdown
                name="gender"
                style={{ maxHeight: '27rem' }}
                placeholder="Select gender"
                fluid
                selection
                options={genders}
                value={selectedGender}
                onChange={(_, { value }) => setSelectedGender(value)}
              />
              {showValidation && !selectedGender && (
                <p className="error">gender is required</p>
              )}
            </div>
            <h5 className="ui dividing header">
              You must enter one of the following:
            </h5>
            {showValidation && !ssnAlienPopulated() && (
              <p className="error">
                One of the following must be entered: Last 4 of Social Security
                number, Alien, or Non Alien number
              </p>
            )}
            <div className="field">
              <label htmlFor="ssnLast_4">
                Last 4 digits of Social Security Number
              </label>
              <input
                name="ssnLast_4"
                placeholder="SSN Last 4 Number"
                value={ssnLast_4}
                onChange={(e) => setSsnLast_4(e.target.value)}
              />
              {showValidation &&
                ssnLast_4.length !== 0 &&
                ssnLast_4.length !== 4 && (
                  <p className="error">
                    Last 4 Social Security number must be 4 digits
                  </p>
                )}
            </div>
            <div className="field">
              <label htmlFor="alienNumber">Alien Number</label>
              <div className="ui icon input">
                <input
                  name="alienNumber"
                  placeholder="Alien Number"
                  value={alienNumber}
                  onChange={(e) => setAlienNumber(e.target.value)}
                />
                <i
                  className="question circle link icon"
                  onClick={() => setShowAlienModal(true)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="nonAlienNumber">Non Alien Number</label>
              <div className="ui icon input">
                <input
                  name="nonAlienNumber"
                  placeholder="Non Alien Number"
                  value={nonAlienNumber}
                  onChange={(e) => setNonAlienNumber(e.target.value)}
                />
                <i
                  className="question circle link icon"
                  onClick={() => setShowAlienModal(true)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
            <input
              className="ui primary button"
              type="submit"
              value={submitting ? 'Submitting...' : 'Submit'}
              disabled={submitting}
            />
          </div>
        </div>
      </div>
      <Modal
        open={showAlienModal}
        onClose={() => setShowAlienModal(false)}
        size="large"
      >
        <Modal.Header>Alien Number / Non Alien Number Information</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p>
              During the registration process the state requires you to enter an
              Alien Number, Non Alien Number, or last 4 digits of Social
              Security Number (SSN). Most Alien Numbers are listed as the
              registration number on the front of your Visa. However, if your
              Visa does not have a registration number there will be a Passport
              Number listed instead, and this would be the number you would want
              to enter in the Non Alien Number field. The registration number is
              generally either 8 or 9 digits in length and an example of the
              most common format would be 000-001-002. If you are utilizing your
              passport number it would be in the format of AB123456.
            </p>
            <p>Alien numbers can also be referred to as:</p>
            <ul>
              <li>Alien registration numbers</li>
              <li>USCIS numbers</li>
              <li>or A-numbers</li>
            </ul>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="ui button"
            onClick={() => setShowAlienModal(false)}
          >
            Close
          </button>
        </Modal.Actions>
      </Modal>
    </form>
  );
};

export default GatherInfoFLDETS;
